import React, { useState, useEffect } from "react";
import * as am4core from "@amcharts/amcharts4/core";
import {
	IOverviewChannel,
	IChannelTS,
	IChannelFC,
	getChannelTS
} from "../../../services/api/Dashboard";
import Year, { IYear } from "../../../services/api/Year";
import Month, { IMonth } from "../../../services/api/Month";
import Select from "../../../components/Form/Select";
import Mapa from "./charts/Mapa";
import Donut from "./charts/Donut";
import Waterfall from "./charts/Waterfall";
import Loading from "../../../components/Loading";
import Formatter from "../../../services/utils/Formatter";
import { getOverviewChannels } from "./channelCache";

const ChannelOverview: React.FC = () => {
	const [loading, isLoading] = useState<Boolean>(true);
	const [years, setYears] = useState<IYear[]>([]);
	const [months, setMonths] = useState<IMonth[]>([]);
	const [current, setOverview] = useState<IOverviewChannel>({} as IOverviewChannel);
	const [monthOverview, setMonthOverview] = useState<IOverviewChannel | null>(null);

	const [year, setYear] = useState<number>(0);
	const [month, setMonth] = useState<number>(0);
	const [tstype1, setType1] = useState<string>("BP");
	const [tstype2, setType2] = useState<string>("BP");
	const [tstype3, setType3] = useState<string>("BP");
	const [fWeek, setFWeek] = useState<string>("FW1");
	const [fType, setFType] = useState<string | null>();
	const [fVs, setFVs] = useState<string>("BP");
	const [fPs, setFPs] = useState<string>("MONTH");
	const graphColors: string[] = ["#00162b", "#00162b", "#07173b", "#ff1054", "#ffc000", "#656061", "#F4801F"];
	const monthNames = ["", "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

	const date = new Date();

	let mapData: object[] = [];
	let valueBPTotal: number = 0;
	let valueTSTotal: number = 0;
	let valueMapTotal: number = 0;
	let valueIncrease: number = 0;
	let valueDecrease: number = 0;

	let valueLYActTotal: number = 0;
	let valueLYIncrease: number = 0;
	let valueLYDecrease: number = 0;

	const countries: Array<IOverviewChannel> = [];
	const majors: Array<IOverviewChannel> = [];
	let all: Array<IOverviewChannel> = [];
	let allMonth: Array<IOverviewChannel> = [];

	async function LoadOverview(year: number, month: number) {
		isLoading(true);

		const {overview, ytdOverview} = await getOverviewChannels(year, month);
		setOverview(fPs === "YTD" ? ytdOverview : overview);
		setMonthOverview(fPs === "YTD" ? overview : null);

		isLoading(false);
	}

	useEffect(() => {
		Promise.all([Year.GetAll(), Month.GetAll()])
			.then((value) => {
				const years = value[0].filter((value) => { return value.active });
				setYears(years);
				setMonths(value[1]);

				setYear(years[0].name);
				setMonth(date.getMonth() + 1);

				LoadOverview(years[0].name, date.getMonth() + 1);
			})
			.catch(console.log);
	}, []);

	useEffect(() => {
		if (!loading) LoadOverview(year, month);

	}, [year, month, fPs]);

	function mapList(obj: any): any {
		return { value: obj.id, label: obj.name };
	}

	function filterSales(obj: any): boolean { return obj.isSales }
	function filterNotSales(obj: any): boolean { return !obj.isSales }

	function mapChannels(obj: IOverviewChannel) {
		const channelsFC: IChannelFC[] = obj.forecastChannels.filter(filterSales);
		const channelsTS: IChannelTS[] = obj.tradeSalesChannels.filter(filterSales);

		// Get current month info to calculate YTD
		let currentValue: number = 0;
		let monthChild: IOverviewChannel | undefined = undefined;
		if(monthOverview) {
			monthChild = monthOverview.children.find((child: IOverviewChannel) => child.code === obj.code);
		}

		return (
			<tr key={"channel" + obj.name}>
				<td>{obj.name}</td>
				{channelsTS.map((children: IChannelTS, i: number) => {
					
					let valueBase: number = 0;
					let valueBaseYTD: number = 0;
					let valueTS: number = 0;

					valueBase = getChannelTS(children, tstype2);
					let channel: IChannelFC = channelsFC[i];

					if(monthChild && fPs !== 'MONTH'){
						let monthFS = monthChild.forecastChannels.find((child: IChannelFC) => child.name === children.name) as IChannelFC;
						let monthTS = monthChild.tradeSalesChannels.find((child: IChannelTS) => child.name === children.name) as IChannelTS;

						currentValue =
							fWeek === "ACT" ? monthTS.tradeSalesActual :
							fWeek === "FW1" ? monthFS.tradeSalesForecastWeek1 :
							fWeek === "FW2" ? monthFS.tradeSalesForecastWeek2 :
							fWeek === "FW3" ? monthFS.tradeSalesForecastWeek3 :
							fWeek === "FW4" ? monthFS.tradeSalesForecastWeek4 :
												fWeek === "MTDW1" ? monthFS.tradeSalesMonthTodayWeek1 :
													fWeek === "MTDW2" ? monthFS.tradeSalesMonthTodayWeek2 :
														fWeek === "MTDW3" ? monthFS.tradeSalesMonthTodayWeek3 :
															fWeek === "MTDW4" ? monthFS.tradeSalesMonthTodayWeek4 : 0;

						valueTS = children.tradeSalesActual;

						valueBaseYTD = getChannelTS(monthTS, tstype2);
					}else {
						valueTS =
							fWeek === "ACT" ? children.tradeSalesActual :
							fWeek === "FW1" ? channel.tradeSalesForecastWeek1 :
							fWeek === "FW2" ? channel.tradeSalesForecastWeek2 :
							fWeek === "FW3" ? channel.tradeSalesForecastWeek3 :
							fWeek === "FW4" ? channel.tradeSalesForecastWeek4 :
												fWeek === "MTDW1" ? channel.tradeSalesMonthTodayWeek1 :
													fWeek === "MTDW2" ? channel.tradeSalesMonthTodayWeek2 :
														fWeek === "MTDW3" ? channel.tradeSalesMonthTodayWeek3 :
															fWeek === "MTDW4" ? channel.tradeSalesMonthTodayWeek4 : 0;
					}

					valueTS += currentValue;
					valueBase += valueBaseYTD;

					return (
						<React.Fragment key={obj.name + children.name}>
							<td>{Formatter.DisplayValue(valueTS)}</td>
							<td className="table__data--border">{Formatter.DisplayPercent((valueTS / valueBase - 1) * 100)}</td>
						</React.Fragment>
					);
				})}
			</tr>
		);
	}

	function filterContent(obj: IOverviewChannel, isYTD: boolean = false) {
		if(isYTD){

			if (obj.children) {
				obj.children.forEach((objC) => {
					filterContent(objC, true);
				});
			}

			if(!obj.featured)
				allMonth.push(obj);

		}else {

			if (obj.longitude !== 0 && obj.latitude !== 0)
				countries.push(obj);

			if (obj.children) {
				obj.children.forEach((objC) => {
					filterContent(objC);
				});
			}

			if (obj.featured)
				majors.push(obj);
			else
				all.push(obj);
		}
	}

	function filterCasaCountries(otherElements: Array<IOverviewChannel>) {
		let allOthers: IOverviewChannel = {
			name: 'All Others',
			tradeSalesChannels: [] as IChannelTS[],
			forecastChannels: [] as IChannelFC[],
			lastYear: {
					name: 'All Others',
					tradeSalesChannels: [] as IChannelTS[],
					forecastChannels: [] as IChannelFC[]

			} as IOverviewChannel
		} as IOverviewChannel;

		const channelsFC: IChannelFC[] = otherElements[0].forecastChannels.filter(filterSales);
		const channelsTS: IChannelTS[] = otherElements[0].tradeSalesChannels.filter(filterSales);

		channelsTS.forEach((children: IChannelTS, j: number) => {
			allOthers.tradeSalesChannels.push({
				name: children.name,
				tradeSalesSRE: 0,
				tradeSalesFRE: 0,
				tradeSalesLE: 0,
				tradeSalesOP: 0,
				tradeSalesBusinessPlan: 0,
				tradeSalesActual: 0,
				isSales: true
			} as IChannelTS);
			allOthers.lastYear.tradeSalesChannels.push({
				name: children.name,
				tradeSalesSRE: 0,
				tradeSalesFRE: 0,
				tradeSalesLE: 0,
				tradeSalesOP: 0,
				tradeSalesBusinessPlan: 0,
				tradeSalesActual: 0,
				isSales: true
			} as IChannelTS);
		});
		channelsFC.forEach((children: IChannelFC, j: number) => {
			allOthers.forecastChannels.push({
				name: children.name,
				tradeSalesForecastWeek1: 0,
				tradeSalesForecastWeek2: 0,
				tradeSalesForecastWeek3: 0,
				tradeSalesForecastWeek4: 0,
				tradeSalesFCT: 0,
				isSales: true
			} as IChannelFC);
			allOthers.lastYear.forecastChannels.push({
				name: children.name,
				tradeSalesForecastWeek1: 0,
				tradeSalesForecastWeek2: 0,
				tradeSalesForecastWeek3: 0,
				tradeSalesForecastWeek4: 0,
				tradeSalesFCT: 0,
				isSales: true
			} as IChannelFC);
		});
		otherElements.forEach((obj: IOverviewChannel, index: number) => {
			if (index > 8 && obj.level > 1) {

				allOthers.year = obj.year;
				const channelsFC: IChannelFC[] = obj.forecastChannels.filter(filterSales);
				const channelsTS: IChannelTS[] = obj.tradeSalesChannels.filter(filterSales);

				channelsTS.forEach((children: IChannelTS, j: number) => {
					allOthers.tradeSalesChannels[j].tradeSalesSRE = children.tradeSalesSRE;
					allOthers.tradeSalesChannels[j].tradeSalesFRE = children.tradeSalesFRE;
					allOthers.tradeSalesChannels[j].tradeSalesLE = children.tradeSalesLE;
					allOthers.tradeSalesChannels[j].tradeSalesOP = children.tradeSalesOP;
					allOthers.tradeSalesChannels[j].tradeSalesBusinessPlan = children.tradeSalesBusinessPlan;
					allOthers.tradeSalesChannels[j].tradeSalesActual = children.tradeSalesActual;
				});
				channelsFC.forEach((children: IChannelFC, j: number) => {
					allOthers.forecastChannels[j].tradeSalesForecastWeek1 = children.tradeSalesForecastWeek1;
					allOthers.forecastChannels[j].tradeSalesForecastWeek2 = children.tradeSalesForecastWeek2;
					allOthers.forecastChannels[j].tradeSalesForecastWeek3 = children.tradeSalesForecastWeek3;
					allOthers.forecastChannels[j].tradeSalesForecastWeek4 = children.tradeSalesForecastWeek4;
					allOthers.forecastChannels[j].tradeSalesFCT = children.tradeSalesFCT;
				});


				if (obj.lastYear) {
					allOthers.lastYear.year = obj.lastYear.year;
					if(obj.lastYear.tradeSalesChannels)
						obj.lastYear.tradeSalesChannels.filter(filterSales).forEach((children: IChannelTS, j: number) => {
							allOthers.lastYear.tradeSalesChannels[j].tradeSalesSRE = children.tradeSalesSRE;
							allOthers.lastYear.tradeSalesChannels[j].tradeSalesFRE = children.tradeSalesFRE;
							allOthers.lastYear.tradeSalesChannels[j].tradeSalesLE = children.tradeSalesLE;
							allOthers.lastYear.tradeSalesChannels[j].tradeSalesOP = children.tradeSalesOP;
							allOthers.lastYear.tradeSalesChannels[j].tradeSalesBusinessPlan = children.tradeSalesBusinessPlan;
							allOthers.lastYear.tradeSalesChannels[j].tradeSalesActual = children.tradeSalesActual;
						});

					if (obj.lastYear.forecastChannels)
						obj.lastYear.forecastChannels.filter(filterSales).forEach((children: IChannelFC, j: number) => {
							allOthers.lastYear.forecastChannels[j].tradeSalesForecastWeek1 = children.tradeSalesForecastWeek1;
							allOthers.lastYear.forecastChannels[j].tradeSalesForecastWeek2 = children.tradeSalesForecastWeek2;
							allOthers.lastYear.forecastChannels[j].tradeSalesForecastWeek3 = children.tradeSalesForecastWeek3;
							allOthers.lastYear.forecastChannels[j].tradeSalesForecastWeek4 = children.tradeSalesForecastWeek4;
							allOthers.lastYear.forecastChannels[j].tradeSalesFCT += children.tradeSalesFCT;
						});
				}
			}
		});

		return allOthers;
	}

	if (!loading) {
		filterContent(current);

		let allOthers = filterCasaCountries(all)
		all.splice(9);
		all = all.concat(allOthers, current);

		if(monthOverview && fPs !== 'MONTH'){
			filterContent(monthOverview, true);
			let allOthersMonth = filterCasaCountries(allMonth)
			allMonth.splice(9);
			allMonth = allMonth.concat(allOthersMonth, monthOverview);
		}

		countries.forEach((obj: IOverviewChannel, i: number) => {

			let valueBaseBP: number = 0;
			let valueBaseTS: number = 0;
			let valueBaseMap: number = 0;

			const fsChannels: IChannelFC[] = obj.forecastChannels.filter(filterSales);
			const tsChannels: IChannelTS[] = obj.tradeSalesChannels.filter(filterSales);

			let currentValue: number = 0;
			let monthChild: IOverviewChannel | undefined = undefined;
			if(monthOverview) {
				monthChild = monthOverview.children.find((child: IOverviewChannel) => child.code === obj.code);
				if(!monthChild){
					const casaChild = monthOverview.children.find((child: IOverviewChannel) => child.code === 'CASA');
					if(casaChild)
						monthChild = casaChild.children.find((child: IOverviewChannel) => child.code === obj.code);
				}
			}
			const isYTD = fPs !== 'MONTH'

			tsChannels.forEach((children: IChannelTS, j: number) => {
				if (fType === children.name || fType === undefined) {
					
					valueBaseBP += getChannelTS(children, tstype3);

					let channel: IChannelFC = fsChannels[j];

					let monthFS = {} as IChannelFC;
					let monthTS = {} as IChannelTS;

					if(isYTD && monthChild){
						monthFS = monthChild.forecastChannels.find((child: IChannelFC) => child.name === children.name) as IChannelFC;
						monthTS = monthChild.tradeSalesChannels.find((child: IChannelTS) => child.name === children.name) as IChannelTS;
						currentValue += 
							fWeek === "ACT" ? monthTS.tradeSalesActual :
							fWeek === "FW1" ? monthFS.tradeSalesForecastWeek1 :
							fWeek === "FW2" ? monthFS.tradeSalesForecastWeek2 :
							fWeek === "FW3" ? monthFS.tradeSalesForecastWeek3 :
							fWeek === "FW4" ? monthFS.tradeSalesForecastWeek4 :
							fWeek === "MTDW1" ? monthFS.tradeSalesMonthTodayWeek1 :
							fWeek === "MTDW2" ? monthFS.tradeSalesMonthTodayWeek2 :
							fWeek === "MTDW3" ? monthFS.tradeSalesMonthTodayWeek3 :
							monthFS.tradeSalesMonthTodayWeek4;

						valueBaseTS += children.tradeSalesActual;

						valueBaseBP += getChannelTS(monthTS, tstype3);
						
					}else{
						valueBaseTS +=
							fWeek === "ACT" ? children.tradeSalesActual :
							fWeek === "FW1" ? channel.tradeSalesForecastWeek1 :
							fWeek === "FW2" ? channel.tradeSalesForecastWeek2 :
							fWeek === "FW3" ? channel.tradeSalesForecastWeek3 :
							fWeek === "FW4" ? channel.tradeSalesForecastWeek4 :
							fWeek === "MTDW1" ? channel.tradeSalesMonthTodayWeek1 :
							fWeek === "MTDW2" ? channel.tradeSalesMonthTodayWeek2 :
							fWeek === "MTDW3" ? channel.tradeSalesMonthTodayWeek3 :
							channel.tradeSalesMonthTodayWeek4;
					}
					
					
					if (fVs === "BP"){
						valueBaseMap += children.tradeSalesBusinessPlan;
						if(isYTD)
							valueBaseMap += monthTS.tradeSalesBusinessPlan;
					}
					else if (fVs === "FRE") {
						valueBaseMap += children.tradeSalesFRE;
						if(isYTD)
							valueBaseMap += monthTS.tradeSalesFRE;
					}
					else if (fVs === "SRE") {
						valueBaseMap += children.tradeSalesSRE;
					} 
					else if (fVs === "LE")
						valueBaseMap += children.tradeSalesLE;
					else if (fVs === "OP")
						valueBaseMap += children.tradeSalesOP;
					else if (fVs === "LFCT") {
						valueBaseMap +=
							fWeek === "ACT" ? channel.tradeSalesForecastWeek4 : 
							fWeek === "FW4" ? channel.tradeSalesForecastWeek3 :
							fWeek === "FW3" ? channel.tradeSalesForecastWeek2 :
							fWeek === "FW2" ? channel.tradeSalesForecastWeek1 :
										fWeek === "FW1" ? channel.tradeSalesForecastWeek1 :
							fWeek === "MTDW4" ? channel.tradeSalesMonthTodayWeek3 :
							fWeek === "MTDW3" ? channel.tradeSalesMonthTodayWeek2 :
							fWeek === "MTDW2" ? channel.tradeSalesMonthTodayWeek1 :
							channel.tradeSalesMonthTodayWeek1; }
					else if (fVs === "ACT") {
						valueBaseMap += children.tradeSalesActual;
						if(isYTD)
							valueBaseMap += monthTS.tradeSalesActual;
					}
					else { // LY
						if (obj.lastYear.forecastChannels && obj.lastYear.forecastChannels.filter(filterSales).length > 0)
							valueBaseMap += obj.lastYear.forecastChannels.filter(filterSales)[j].tradeSalesFCT;
					}
				}
			});


			valueBaseTS += currentValue;

			const financialSalesClosing: number = obj.lastYear.forecastChannels ? obj.lastYear.forecastChannels.filter(filterNotSales)[0].tradeSalesFCT : 0;

			valueBPTotal += valueBaseBP;
			valueTSTotal += valueBaseTS;
			valueMapTotal += valueBaseMap;
			valueLYActTotal += financialSalesClosing;

			let diff: number = valueBaseTS - valueBaseBP;
			if (diff > 0) valueIncrease += diff;
			else valueDecrease += diff;

			diff = valueBaseTS - financialSalesClosing;
			if (diff > 0) valueLYIncrease += diff;
			else valueLYDecrease += diff;

			diff = valueBaseTS - valueBaseMap;

			mapData.push({
				title: obj.name,
				latitude: obj.latitude,
				longitude: obj.longitude,
				value: valueBaseTS,
				size: 0
			});
		});

		//Populate Map
		mapData.forEach((obj: any, i: number) => {
			let value = Math.max(2, Math.abs(100 * obj.value) / (valueMapTotal == 0 ? valueTSTotal : valueMapTotal));
			obj.size = Number.isNaN(value) ? 1 : value;
		});
	}

	function getGraphData(){
		let LFC = 0;
		let FC = 0;
		const graphData: any = [];

		const fsChannels: IChannelFC[] = current.forecastChannels.filter(filterSales);
		const tsChannels: IChannelTS[] = current.tradeSalesChannels.filter(filterSales);
		let fsMonthChannels: IChannelFC[] = [];
		let tsMonthChannels: IChannelTS[] = [];
		const isYTD = fPs !== 'MONTH'

		if(isYTD && monthOverview){
			fsMonthChannels = monthOverview.forecastChannels.filter(filterSales);
			tsMonthChannels = monthOverview.tradeSalesChannels.filter(filterSales);
		}
		

		fsChannels.forEach((obj: IChannelFC, index: number) => {
			let fcv = 0;

			if(isYTD && monthOverview){
				let currentValue = 
					fWeek === "ACT" ? tsMonthChannels[index].tradeSalesActual :
					fWeek === "FW1" ? fsMonthChannels[index].tradeSalesForecastWeek1 :
					fWeek === "FW2" ? fsMonthChannels[index].tradeSalesForecastWeek2 :
					fWeek === "FW3" ? fsMonthChannels[index].tradeSalesForecastWeek3 :
					fWeek === "FW4" ? fsMonthChannels[index].tradeSalesForecastWeek4 :
					fWeek === "MTDW1" ? fsMonthChannels[index].tradeSalesMonthTodayWeek1 :
					fWeek === "MTDW2" ? fsMonthChannels[index].tradeSalesMonthTodayWeek2 :
					fWeek === "MTDW3" ? fsMonthChannels[index].tradeSalesMonthTodayWeek3 :
					fsMonthChannels[index].tradeSalesMonthTodayWeek4;

				fcv = tsChannels[index].tradeSalesActual;
				fcv += currentValue;
			}else{
				fcv =
					fWeek === "ACT" ? tsChannels[index].tradeSalesActual :
					fWeek === "FW1" ? obj.tradeSalesForecastWeek1 :
					fWeek === "FW2" ? obj.tradeSalesForecastWeek2 :
					fWeek === "FW3" ? obj.tradeSalesForecastWeek3 :
					fWeek === "FW4" ? obj.tradeSalesForecastWeek4 :
					fWeek === "MTDW1" ? obj.tradeSalesMonthTodayWeek1 :
					fWeek === "MTDW2" ? obj.tradeSalesMonthTodayWeek2 :
					fWeek === "MTDW3" ? obj.tradeSalesMonthTodayWeek3 :
					obj.tradeSalesMonthTodayWeek4;
			}
			

			let lfcv = 0;

			if (fVs === "BP") {
				lfcv = tsChannels[index].tradeSalesBusinessPlan;
				if(tsMonthChannels[index] !== undefined)
					lfcv += tsMonthChannels[index].tradeSalesBusinessPlan;
			} else if (fVs === "FRE") {
				lfcv = tsChannels[index].tradeSalesFRE;
				if(tsMonthChannels[index] !== undefined)
					lfcv += tsMonthChannels[index].tradeSalesFRE;
			} else if (fVs === "SRE") {
				lfcv = tsChannels[index].tradeSalesSRE;
			} else if (fVs === "LE") {
				lfcv = tsChannels[index].tradeSalesLE;
			} else if (fVs === "OP") {
				lfcv = tsChannels[index].tradeSalesOP;
			} else if (fVs === "LFCT") {
				lfcv =
				fWeek === "ACT" ? obj.tradeSalesForecastWeek4 :
				fWeek === "FW4" ? obj.tradeSalesForecastWeek3 :
				fWeek === "FW3" ? obj.tradeSalesForecastWeek2 :
				fWeek === "FW2" ? obj.tradeSalesForecastWeek1 :
				fWeek === "FW1" ? obj.tradeSalesForecastWeek1 :
				fWeek === "MTDW4" ? obj.tradeSalesMonthTodayWeek3 :
				fWeek === "MTDW3" ? obj.tradeSalesMonthTodayWeek2 :
				fWeek === "MTDW2" ? obj.tradeSalesMonthTodayWeek1 :
													obj.tradeSalesMonthTodayWeek1;
			} else if (fVs === "ACT") {
				lfcv = tsChannels[index].tradeSalesActual;
				if(tsMonthChannels[index] !== undefined)
					lfcv += tsMonthChannels[index].tradeSalesActual;
			} else { // LY
				if(current.lastYear.forecastChannels.filter(filterSales)[index] !== undefined)
					lfcv = current.lastYear.forecastChannels.filter(filterSales)[index].tradeSalesFCT;
			}

			graphData.push({
				category: obj.name,
				value: fcv - lfcv
			});

			LFC += lfcv;
			FC += fcv;
		});

		graphData.splice(0, 0, {
			category: fVs,
			value: LFC
		});
		graphData.push({
			category: "FCT",
			value: FC
		});

		return graphData;
	}

	return (
		<React.Fragment>
			{loading ? (
				<Loading />
			) : (
					<React.Fragment>
						<section className="content__block">
							<div className="map-info">
								<h2 className="content__title">Sales - {current.code}</h2>
								<div className="sales-box">
									<div className="row row--vCenter sales-box__header">
										<div className="content__select">
											<Select
												name="tstype3"
												title="Reference"
												className="select-custom select-custom--small"
												options={[
													{ value: "BP", label: "BP" },
													{ value: "FRE", label: "FRE" },
													{ value: "SRE", label: "SRE" },
													{ value: "LE", label: "LE" },
													{ value: "OP", label: "OP" }
												]}
												value={tstype3}
												handleChange={(event: React.FormEvent<HTMLSelectElement>) => {
													setType3(event.currentTarget.value);
												}}
											/>
										</div>
									</div>
									<div className="row row--vCenter sales-box__header">
										<div className="col--2">
											<h3 className="sales-box__title">Forecast</h3>
										</div>
										<div className="col--2">
											<span className="sales-box__total">{Formatter.DisplayValue(valueTSTotal)}</span>
										</div>
									</div>
									<div className="container-row">
										<h4 className="sales-box__subtitle">{monthNames[month]} { tstype3 } {current.year}</h4>
										<div className="row">
											<div className="col--2">
												<p className="sales-box__item">Increase vs Comparison</p>
											</div>
											<div className="col--2">
												<div className="sales-box__values sales-box__values--blue">
													<span className="dot dot--blue"></span>
													<span>{Formatter.DisplayValue(valueIncrease)}</span>
													<span>{Formatter.DisplayPercent(valueIncrease / valueTSTotal * 100)}</span>
												</div>
											</div>
										</div>
										<div className="row">
											<div className="col--2">
												<p className="sales-box__item">Decrease vs Comparison</p>
											</div>
											<div className="col--2">
												<div className="sales-box__values sales-box__values--red">
													<span className="dot dot--red"></span>
													<span>{Formatter.DisplayValue(valueDecrease)}</span>
													<span>{Formatter.DisplayPercent(valueDecrease / valueTSTotal * 100)}</span>
												</div>
											</div>
										</div>
										<div className="row">
											<div className="col--2">
												<p className="sales-box__item">{tstype3} Comparison</p>
											</div>
											<div className="col--2">
												<div className="sales-box__values sales-box__values--gray">
													<span>{Formatter.DisplayValue(valueBPTotal)}</span>
													<span>{Formatter.DisplayPercent((valueTSTotal / valueBPTotal - 1) * 100)}</span>
												</div>
											</div>
										</div>
									</div>
									<div className="container-row">
										<h4 className="sales-box__subtitle"> {monthNames[month]} ACT {current.lastYear.year} </h4>
										<div className="row">
											<div className="col--2">
												<p className="sales-box__item">Increase vs Comparison</p>
											</div>
											<div className="col--2">
												<div className="sales-box__values sales-box__values--blue">
													<span className="dot dot--blue"></span>
													<span>{Formatter.DisplayValue(valueLYIncrease)}</span>
													<span>{Formatter.DisplayPercent((valueLYIncrease / valueTSTotal) * 100)} </span>
												</div>
											</div>
										</div>

										<div className="row">
											<div className="col--2">
												<p className="sales-box__item">Decrease vs Comparison</p>
											</div>
											<div className="col--2">
												<div className="sales-box__values sales-box__values--red">
													<span className="dot dot--red"></span>
													<span>{Formatter.DisplayValue(valueLYDecrease)}</span>
													<span>{Formatter.DisplayPercent(valueLYDecrease / valueTSTotal * 100)}</span>
												</div>
											</div>
										</div>
										<div className="row">
											<div className="col--2">
												<p className="sales-box__item">LY Comparison</p>
											</div>
											<div className="col--2">
												<div className="sales-box__values sales-box__values--gray">
													<span>{Formatter.DisplayValue(valueLYActTotal)}</span>
													<span>{Formatter.DisplayPercent((valueTSTotal / valueLYActTotal - 1) * 100)}</span>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div className="legend">
									<p>
										<span className="dot dot--blue"></span>
									  Positive variation vs scenario observed.
									</p>
									<p>
										<span className="dot dot--red"></span>
									  Negative variation vs scenario observed.
									</p>
								</div>
								<div className="countries">
									<div className="countries__countainer">
										<div className="countries__count">
											<span className="countries__number">
												{countries.length}
											</span>
											<span className="countries__label">
												Countries <br /> /Territories
                    </span>
										</div>
										<p className="countries__description">
											The size will represent the variation observed vs the
											scenarios. A channel filter can be used to read variation of
											all Latam countries by channel.
                  </p>
									</div>
								</div>
								<Mapa id="map" data={mapData} />
								<div className="map-info__control">
									<div className="content__select">
										<Select
											name="fWeek"
											title="Current"
											className="select-custom select-custom--small select-custom--shadow"
											options={[
												{ value: "FW1", label: "FW1" },
												{ value: "FW2", label: "FW2" },
												{ value: "FW3", label: "FW3" },
												{ value: "FW4", label: "FW4" },
												{ value: "MTDW1", label: "MTDW1" },
												{ value: "MTDW2", label: "MTDW2" },
												{ value: "MTDW3", label: "MTDW3" },
												{ value: "MTDW4", label: "MTDW4" },
												{ value: "ACT", label: "CLOSING" }
											]}
											value={fWeek}
											handleChange={(
												event: React.FormEvent<HTMLSelectElement>
											) => {
												setFWeek(event.currentTarget.value);
											}}
										/>

										<Select
											className="select-custom select-custom--medium select-custom--shadow"
											name="month"
											title="Month"
											options={months.map(mapList)}
											value={month}
											handleChange={(
												event: React.FormEvent<HTMLSelectElement>
											) => {
												setMonth(+event.currentTarget.value);
											}}
										/>

										<Select
											className="select-custom select-custom--medium select-custom--shadow"
											name="year"
											title="Year"
											options={years.map((obj) => { return { value: obj.name, label: obj.name } })}
											value={year}
											handleChange={(
												event: React.FormEvent<HTMLSelectElement>
											) => {
												setYear(+event.currentTarget.value);
											}}
										/>
									</div>

									<div className="content__select">
										<Select
											className="select-custom select-custom--medium select-custom--shadow"
											name=""
											title="Channel"
											options={[{ value: "", label: "Total" }].concat(
												current.tradeSalesChannels.filter(filterSales).map((obj: IChannelTS) => {
													return { value: obj.name, label: obj.name };
												})
											)}
											value={fType}
											handleChange={(
												event: React.FormEvent<HTMLSelectElement>
											) => {
												setFType(event.currentTarget.value === "" ? undefined : event.currentTarget.value);
											}}
										/>

										<Select
											title="Period"
											name="fPs"
											className="select-custom select-custom--big select-custom--shadow"
											options={[
												{ value: "MONTH", label: "Month" },
												{ value: "YTD", label: "YTD" }
											]}
											value={fPs}
											handleChange={(
												event: React.FormEvent<HTMLSelectElement>
											) => {
												setFPs(event.currentTarget.value);
											}}
										/>

										<Select
											name="fVs"
											title="Vs"
											className="select-custom select-custom--big select-custom--shadow"
											options={[
												{ value: "BP", label: "BP" },
												{ value: "FRE", label: "FRE" },
												{ value: "SRE", label: "SRE" },
												{ value: "LE", label: "LE" },
												{ value: "OP", label: "OP" },
												{ value: "LFCT", label: "LFCT" },
												{ value: "LY", label: "LY" },
												{ value: "ACT", label: "CLOSING" }
											]}
											value={fVs}
											handleChange={(
												event: React.FormEvent<HTMLSelectElement>
											) => {
												setFVs(event.currentTarget.value);
											}}
										/>

									</div>
								</div>
							</div>
						</section>

						<section className="content__block">
							<div className="content__select">
								<Select
									name="tstype1"
									title="Reference"
									className="select-custom select-custom--small"
									options={[
										{ value: "BP", label: "BP" },
										{ value: "FRE", label: "FRE" },
										{ value: "SRE", label: "SRE" },
										{ value: "LE", label: "LE" },
										{ value: "OP", label: "OP" }
									]}
									value={tstype1}
									handleChange={(event: React.FormEvent<HTMLSelectElement>) => {
										setType1(event.currentTarget.value);
									}}
								/>
							</div>
							<div className="row">
								<div className="col--small">
									<div className="table">
										<table className="table__data">
											<tbody>
												<tr>
													<th>COUNTRIES</th>
													<th>FORECAST</th>
													<th>VS. LY</th>
													<th>VS. {tstype1}</th>
												</tr>
												{ majors.map((obj: IOverviewChannel, i: number) => {

														// Get current month info to calculate YTD
														let currentValue: number = 0;
														let monthChild: IOverviewChannel | undefined = undefined;
														if(monthOverview) {
															monthChild = monthOverview.children.find((child: IOverviewChannel) => child.code === obj.code);
														}

														let valueBase: number = 0;
														let valueBaseYTD: number = 0;
														let valueLY: number = 0;
														let valueTS: number = 0;

														const fsChannels: IChannelFC[] = obj.forecastChannels.filter(filterSales);
														const tsChannels: IChannelTS[] = obj.tradeSalesChannels.filter(filterSales);

														tsChannels.forEach(
															(children: IChannelTS, j: number) => {
																if (
																	fType === children.name ||
																	fType === undefined
																) {
																	valueBase += getChannelTS(children, tstype1);

																	let channel: IChannelFC = fsChannels[j];

																	if(monthChild && fPs !== 'MONTH'){
																		let monthFS = monthChild.forecastChannels.find((child: IChannelFC) => child.name === children.name) as IChannelFC;
																		let monthTS = monthChild.tradeSalesChannels.find((child: IChannelTS) => child.name === children.name) as IChannelTS;

																		currentValue +=
																			fWeek === "ACT" ? monthTS.tradeSalesActual :
																			fWeek === "FW1" ? monthFS.tradeSalesForecastWeek1 :
																			fWeek === "FW2" ? monthFS.tradeSalesForecastWeek2 :
																			fWeek === "FW3" ? monthFS.tradeSalesForecastWeek3 :
																			fWeek === "FW4" ? monthFS.tradeSalesForecastWeek4 :
																			fWeek === "MTDW1" ? monthFS.tradeSalesMonthTodayWeek1 :
																			fWeek === "MTDW2" ? monthFS.tradeSalesMonthTodayWeek2 :
																			fWeek === "MTDW3" ? monthFS.tradeSalesMonthTodayWeek3 :
																			monthFS.tradeSalesMonthTodayWeek4;

																		valueTS += children.tradeSalesActual;

																		valueBaseYTD +=
																			tstype1 === "BP" ? monthTS.tradeSalesBusinessPlan :
																			tstype1 === "SRE" ? monthTS.tradeSalesSRE :
																			monthTS.tradeSalesFRE;
																	}else {

																		valueTS +=
																			fWeek === "ACT" ? children.tradeSalesActual :
																			fWeek === "FW1" ? channel.tradeSalesForecastWeek1 :
																			fWeek === "FW2" ? channel.tradeSalesForecastWeek2 :
																			fWeek === "FW3" ? channel.tradeSalesForecastWeek3 :
																			fWeek === "FW4" ? channel.tradeSalesForecastWeek4 :
																			fWeek === "MTDW1" ? channel.tradeSalesMonthTodayWeek1 :
																			fWeek === "MTDW2" ? channel.tradeSalesMonthTodayWeek2 :
																			fWeek === "MTDW3" ? channel.tradeSalesMonthTodayWeek3 :
																			channel.tradeSalesMonthTodayWeek4;
																	}

																	if (obj.lastYear.forecastChannels && obj.lastYear.forecastChannels.filter(filterSales).length > 0) {
																		valueLY += obj.lastYear.forecastChannels.filter(filterSales)[j].tradeSalesFCT;
																	}
																}
															}
														);

														valueTS += currentValue;
														valueBase += valueBaseYTD;

														return (
															<tr key={"countryData" + obj.name}>
																<td>{obj.name}</td>
																<td>{Formatter.DisplayValue(valueTS)}</td>
																<td>{Formatter.DisplayPercent((valueTS / valueLY - 1) * 100)}</td>
																<td className="table__data--border">{Formatter.DisplayPercent((valueTS / valueBase - 1) * 100)}</td>
															</tr>
														);
												})}
												<tr></tr>
												{ all.map((obj: IOverviewChannel, i: number) => {

													//#region NEW CODE
													let currentValue: number = 0;
													let monthChild: IOverviewChannel | undefined = undefined;
													if(monthOverview) {
														if(obj.code === 'LATAM'){
															monthChild = monthOverview;
														}else{
															const casa = monthOverview.children.find((child: IOverviewChannel) => child.code === 'CASA');
															if(casa)
																monthChild = allMonth.find((child: IOverviewChannel) => child.code === obj.code);
														}
													}
													//#endregion

													let valueBase: number = 0;
													let valueBaseYTD:number = 0;
													let valueLY: number = 0;
													let valueTS: number = 0;

													const fsChannels: IChannelFC[] = obj.forecastChannels.filter(filterSales);
													const tsChannels: IChannelTS[] = obj.tradeSalesChannels.filter(filterSales);

													tsChannels.forEach(
														(children: IChannelTS, j: number) => {
															if (
																fType === children.name ||
																fType === undefined
															) {
																valueBase += getChannelTS(children, tstype1);

																let channel: IChannelFC = fsChannels[j];
																

																if(monthChild && fPs !== 'MONTH'){
																	let monthFS = monthChild.forecastChannels.find((child: IChannelFC) => child.name === children.name) as IChannelFC;
																	let monthTS = monthChild.tradeSalesChannels.find((child: IChannelTS) => child.name === children.name) as IChannelTS;

																	currentValue +=
																		fWeek === "ACT" ? monthTS.tradeSalesActual :
																		fWeek === "FW1" ? monthFS.tradeSalesForecastWeek1 :
																		fWeek === "FW2" ? monthFS.tradeSalesForecastWeek2 :
																		fWeek === "FW3" ? monthFS.tradeSalesForecastWeek3 :
																		fWeek === "FW4" ? monthFS.tradeSalesForecastWeek4 :
																		fWeek === "MTDW1" ? monthFS.tradeSalesMonthTodayWeek1 :
																		fWeek === "MTDW2" ? monthFS.tradeSalesMonthTodayWeek2 :
																		fWeek === "MTDW3" ? monthFS.tradeSalesMonthTodayWeek3 :
																		monthFS.tradeSalesMonthTodayWeek4;

																	valueTS += children.tradeSalesActual;

																	valueBaseYTD +=
																		tstype1 === "BP" ? monthTS.tradeSalesBusinessPlan :
																		tstype1 === "SRE" ? monthTS.tradeSalesSRE :
																		monthTS.tradeSalesFRE;
																}else {
																	valueTS +=
																		fWeek === "ACT" ? children.tradeSalesActual :
																		fWeek === "FW1" ? channel.tradeSalesForecastWeek1 :
																		fWeek === "FW2" ? channel.tradeSalesForecastWeek2 :
																		fWeek === "FW3" ? channel.tradeSalesForecastWeek3 :
																		fWeek === "FW4" ? channel.tradeSalesForecastWeek4 :
																		fWeek === "MTDW1" ? channel.tradeSalesMonthTodayWeek1 :
																		fWeek === "MTDW2" ? channel.tradeSalesMonthTodayWeek2 :
																		fWeek === "MTDW3" ? channel.tradeSalesMonthTodayWeek3 :
																		channel.tradeSalesMonthTodayWeek4;
																}


																if (obj.lastYear.forecastChannels && obj.lastYear.forecastChannels.filter(filterSales).length > 0) {
																	valueLY += obj.lastYear.forecastChannels.filter(filterSales)[j].tradeSalesFCT;
																}
															}
														}
													);

													valueTS += currentValue;
													valueBase += valueBaseYTD;

													return (
														<tr key={"countryData" + obj.name}>
															<td>{obj.name}</td>
															<td>{Formatter.DisplayValue(valueTS)}</td>
															<td>{Formatter.DisplayPercent((valueTS / valueLY - 1) * 100)}</td>
															<td className="table__data--border">{Formatter.DisplayPercent((valueTS / valueBase - 1) * 100)}</td>
														</tr>
													);
												})}
											</tbody>
										</table>
									</div>
								</div>

								<div className="col--big">
									<div className="waterfall">
										<Waterfall id="chartS1div" data={getGraphData()} />
									</div>
									<div className="donuts">
										{current.forecastChannels.filter(filterSales).map(
											(obj: IChannelFC, i: number) => {
												const data: any = [];

												majors.forEach((children, j) => {
													const channel: IChannelFC = children.forecastChannels.filter(filterSales)[i];
													const channelTS: IChannelTS = children.tradeSalesChannels.filter(filterSales)[i];

													let monthChild: IOverviewChannel | undefined = undefined;
													let ts = 0;

													if(monthOverview) {
														monthChild = monthOverview.children.find((child: IOverviewChannel) => child.code === children.code);
													}

													if(monthChild && fPs !== 'MONTH'){
														let monthFS = monthChild.forecastChannels.filter(filterSales)[i];
														let monthTS = monthChild.tradeSalesChannels.filter(filterSales)[i];
														
														ts += channelTS.tradeSalesActual;

														let currentValue =
															fWeek === "ACT" ? monthTS.tradeSalesActual :
															fWeek === "FW1" ? monthFS.tradeSalesForecastWeek1 :
															fWeek === "FW2" ? monthFS.tradeSalesForecastWeek2 :
															fWeek === "FW3" ? monthFS.tradeSalesForecastWeek3 :
															fWeek === "FW4" ? monthFS.tradeSalesForecastWeek4 :
															fWeek === "MTDW1" ? monthFS.tradeSalesMonthTodayWeek1 :
															fWeek === "MTDW2" ? monthFS.tradeSalesMonthTodayWeek2 :
															fWeek === "MTDW3" ? monthFS.tradeSalesMonthTodayWeek3 :
															monthFS.tradeSalesMonthTodayWeek4;

														ts += currentValue;
													}else {
														ts +=
															fWeek === "ACT" ? channelTS.tradeSalesActual :
															fWeek === "FW1" ? channel.tradeSalesForecastWeek1 :
															fWeek === "FW2" ? channel.tradeSalesForecastWeek2 :
															fWeek === "FW3" ? channel.tradeSalesForecastWeek3 :
															fWeek === "FW4" ? channel.tradeSalesForecastWeek4 :
															fWeek === "MTDW1" ? channel.tradeSalesMonthTodayWeek1 :
															fWeek === "MTDW2" ? channel.tradeSalesMonthTodayWeek2 :
															fWeek === "MTDW3" ? channel.tradeSalesMonthTodayWeek3 :
															channel.tradeSalesMonthTodayWeek4;
													}

													data.push({
														country: children.name,
														value: ts,
														color: am4core.color(graphColors[j])
													});
												});

												return (
													<div
														key={"donutGraph" + obj.name + (new Date().getTime())}
														className="donut__box"
													>
														<h3 className="donut__title">{obj.name}</h3>
														<Donut id={obj.name} data={data} />
													</div>
												);
											}
										)}

										<div className="donut__box donut__box--sidebyside">
											<div className="donut__legend donut__box--sidebyside">
												{majors.map(
													(obj: IOverviewChannel, i: number) => {

														return (
															<p
																key={"donutLegend" + obj.name}
																className="donut__country"
															>
																<span
																	className="donut__legend--dot"
																	style={{ backgroundColor: graphColors[i] }}
																></span>
																{obj.name}
															</p>
														);
													}
												)}
											</div>
										</div>
									</div>
								</div>
							</div>
						</section>

						<section className="content__block">
							<div className="content__select">
								<Select
									name="tstype2"
									title="Reference"
									className="select-custom select-custom--small"
									options={[
										{ value: "BP", label: "BP" },
										{ value: "FRE", label: "FRE" },
										{ value: "SRE", label: "SRE" },
										{ value: "LE", label: "LE" },
										{ value: "OP", label: "OP" }
									]}
									value={tstype2}
									handleChange={(event: React.FormEvent<HTMLSelectElement>) => {
										setType2(event.currentTarget.value);
									}}
								/>
							</div>
							<div className="table">
								<table className="table__data">
									<tbody>
										<tr>
											<th>COUNTRIES</th>
											{current.tradeSalesChannels.filter(filterSales).map((obj: IChannelTS) => {
												return (
													<React.Fragment key={obj.name}>
														<th>
															FORECAST <br /> {obj.name}
														</th>
														<th>VS. {tstype2}</th>
													</React.Fragment>
												);
											})}
										</tr>
										{majors.map(mapChannels)}
										<tr></tr>
										{all.map(mapChannels)}
									</tbody>
								</table>
							</div>
						</section>
					</React.Fragment>
				)}
		</React.Fragment>
	);
};

export default ChannelOverview;
